import PointsDistribution from './PointsDistribution';
export  default  PointsDistribution;